import * as types from '../constants/ActionTypes'

const view = (state = {
  mobileMenuOpened: false
}, action) => {
  switch (action.type) {
    case types.TOGGLE_MOBILE_MENU: {
      return  {
        ...state,
        mobileMenuOpened: action.payload
      }
    }
    default:
      return state;
  }
};

export default view;
